/**
 * Drives the shared filters UI (app/views/shared/_filters.html.haml):
 *  * Drives the "Sort" dropdown: clicking an option sets the hidden
 *    filterrific sorted_by select, applied along with the rest of the form
 *    when "Apply filters" is submitted.
 *  * Closes the filters modal on submit. On pages where this form lives
 *    inside a turbo frame (e.g. the story tabs), the frame's content -
 *    including the modal element itself - gets replaced by the turbo
 *    stream response, so Bootstrap never gets to run its own teardown.
 *    Without this, the backdrop and `body.modal-open` are orphaned.
 */
import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["sortSelect", "sortOption", "panel"];

  submit() {
    if (!this.hasPanelTarget) return;

    Modal.getInstance(this.panelTarget)?.hide();
  }

  selectSort({ params: { sortValue } }) {
    if (!this.hasSortSelectTarget) return;

    this.sortSelectTarget.value = sortValue;
    this.sortSelectTarget.dispatchEvent(new Event("change", { bubbles: true }));

    this.sortOptionTargets.forEach((option) => {
      option.classList.toggle(
        "active",
        option.getAttribute("data-forms--filters-sort-value-param") === sortValue,
      );
    });

    this.sortSelectTarget.closest("form").requestSubmit();
  }
}
